import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  htmlToPrint = new BehaviorSubject('-');
  showRx = new BehaviorSubject(false);
  printType :string = 'product';
  toPrintData :any;
  associateId :number = 0;

  isPrinting = false;
  hideSignatures = new BehaviorSubject(<boolean>false);

  public contentReady :boolean = true;

  constructor(
    private router :Router,
    private location :Location,
  ) {}

  printDocument(template :string) {
    setTimeout(() => {
      this.isPrinting = true;
      this.router.navigateByUrl('(print:' + template + ')');
    }, 10);
  }

  onDataReady() {
    const ua = navigator.userAgent;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua,
      )
    ) {
      setTimeout(() => {
        window.print();
        this.isPrinting = false;
        this.contentReady = true;
      }, 1);
    } else {
      setTimeout(() => {
        window.print();
        this.isPrinting = false;
        this.contentReady = true;
        this.location.back();
      });
    }
  }

  printData(htmlString :string, type ?:string) {
    let p_type = this.printType;
    if (type) {
      p_type = type;
    }
    this.htmlToPrint.next(htmlString);
    setTimeout(() => {
      this.printDocument('half-letter');
    }, 1);
  }

  printToLetter(page :string) {
    setTimeout(() => {
      this.isPrinting = true;
      this.router.navigateByUrl('(print:letter/' + page + ')');
    }, 100);
  }
}
